import { render } from "./futurestar2026.vue?vue&type=template&id=5f753731&scoped=true"
import script from "./futurestar2026.vue?vue&type=script&lang=js"
export * from "./futurestar2026.vue?vue&type=script&lang=js"

import "./futurestar2026.vue?vue&type=style&index=0&id=5f753731&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f753731"]])

export default __exports__